<template>
    <f7-page ref="chatChannelPage" :page-content="false" :name="'chat-view-'+ SubscriptionModuleId" class="page-custom">
        <app-header :header="headerTitle" :isChatModule="true" :isShowRightNavBar="!singleChannel && ChannelId === ''"></app-header>
        <app-tab-menu v-if="MainMenuLayout === 1 && !singleChannel && ChannelId === ''"></app-tab-menu>
        <div class="backgroundimg"></div>
        <f7-page-content v-if="!singleChannel && ChannelId === ''">
          <div v-if="headerElements" class="header-section">
            <component v-for="(el,index) in headerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
            </component>
          </div>
            <f7-link v-if="dataLoaded" class="list_display_block" v-for="(ChannelDetails, index1) in ChannelList" :key="index1" :href="showChannel(ChannelDetails.id)">
              <f7-card :key="index1">
                <f7-card-header
                  valign="bottom"
                  :class="{'no-border' : true, card__headerNoImage : !IsValid(ChannelDetails.channelImage) , card__headerImage : IsValid(ChannelDetails.channelImage) }"
                  :style="getChannelImage(ChannelDetails.channelImage)">
                  <div :class="{card__headerNoImageCaption : !IsValid(ChannelDetails.channelImage) , card__headerImageCaption : IsValid(ChannelDetails.channelImage) }">
                    <div class="card__CaptionText">
                      <div>{{ChannelDetails.channelName}}</div>
                      <div class="badge" v-if="ChannelDetails.unreadmsgCount > 0">{{ChannelDetails.unreadmsgCount}}</div>
                    </div>
                    <div v-if="ChannelDetails && ChannelDetails.channelDescription && ChannelDetails.channelDescription.length > 0" class="card__headerOption">
                      <div class="headerOption__description" slot="text" v-html="ChannelDetails.channelDescription"></div>
                    </div>
                  </div>
                </f7-card-header>
              </f7-card>
            </f7-link>
          <div valign="bottom" v-if="footerElements" class="footer-section">
            <component v-for="(el,index) in footerElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
            </component>
          </div>
      </f7-page-content>
      <f7-messagebar v-if="dataLoaded && ChannelId !== ''"
          :placeholder="resource.sendmessageplaceholder"
          :attachments-visible="attachmentsVisible"
          :sheet-visible="sheetVisible"
          :disabled="onsendingimg"
          ref="messagebar"
          class="msg-write-box toolbar-chat"
          @keydown="processTags($event)"
          :class="{'toolbar-bottom-md' : $theme.md}">
          <f7-link
          class="icononly"
          icon-ios="f7:camera_fill"
          icon-aurora="f7:camera_fill"
          icon-md="material:camera_alt"
          slot="inner-start"
          @click="handleActionGrid()">
          </f7-link>
            <input class="filedisplay"
             id="fileuploader" ref="fileuploader"
             type="file" multiple accept="image/*"
            @change="handleSelects" name="images">
           <f7-messagebar-attachments>
            <f7-messagebar-attachment
              v-for="(image, index) in attachments"
              :key="index"
              :image="image"
              @attachment:delete="deleteAttachment(image)">
            </f7-messagebar-attachment>
          </f7-messagebar-attachments>
          <input
            type="text"
            ref="sendMessage"
            class="sendMessageBtn"
            :style="getSendBtnStyle()"
            @focus="onSend(false, $event)"
            @click="onSend(true, $event)"
          /><span class="sendSpanBtn" :style="getSendSpanBtnStyle()"></span>
          <input v-if="getMessageEditingObj.isEditingOn"
            type="text"
            ref="editCancelBtn"
            class="sendMessageBtn"
            :style="getEditCancelBtnStyle()"
            @focus="onEditCancel(false, $event)"
            @click="onEditCancel(true, $event)"
          /><span v-if="getMessageEditingObj.isEditingOn" class="sendSpanBtn" :style="getEditCancelSpanBtnStyle()"></span>
      </f7-messagebar>
       <f7-actions :grid="true" ref="actionGrid" @actions:opened="onActionsOpened" @actions:closed="onActionsClosed">
          <f7-actions-group>
            <f7-actions-button @click="getPicture('CAMERA')">
              <img slot="media" :src="MediaUrlCamera" width="47"/>
              <span>Camera</span>
            </f7-actions-button>
            <f7-actions-button @click="getPicture('PHOTOLIBRARY')" style="left: 30%">
              <img slot="media" :src="MediaUrlPhotoLib" width="47"/>
              <span>Gallery</span>
            </f7-actions-button>
          </f7-actions-group>
        </f7-actions>
      <Chat-View v-if="!isRobotChatOn && dataLoaded && ChannelId !== '' && ChannelDetails.id"
        :ChannelDetails="ChannelDetails"
        :SubscriptionModuleId="SubscriptionModuleId"
        :deletemessage="deletemessage"
        :updatemessage="updatemessage"
        :isShowConnectionWarning="isShowConnectionWarning"
        @onMessageEdit="onMessageEdit"
        @resetDlgProp="isShowConnectionWarning = false">
      </Chat-View>
      <Robot-Chat-View v-else-if="isRobotChatOn" ref="robotChat"></Robot-Chat-View>
      <div ref="connectionwarning" v-if="isShowConnectionWarning" class="warning-popup">
        <div style="position:relative">{{resource.networkErrorMsg}}</div>
        <div class="loader_wrapper">
          <div class="chatspinner"></div>
        </div>
      </div>
    </f7-page>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import * as Helper from "@/modules/helper/index"
    import { isPhoneGap } from '@/modules/util/util'
    import * as phonegapHelper from '@/modules/phonegap/index'
    import * as SignalRHelper from "@/modules/SignalRHelper/index"
    import ChatView from "@/components/chat/ChatNew.vue"
    import RobotChatView from "@/components/chat/RobotChat.vue"
    import imageUrl from '@/css/images/user-icon.svg'
    import sendIcon from '@/css/images/chat-send-image.png'
    import editIcon from '@/css/images/editmessage.png'
    import editCancelIcon from '@/css/images/editcancel.png'
    import DeviceInfo from '@/modules/util/deviceInfo'
    import uniqBy from "lodash.uniqBy"
    export default {
      components: {
        ChatView,
        RobotChatView
      },
      data() {
        return {
          isRobotChatOn: false,
          msecond: null,
          timeouttyping: null,
          responceInProgress: false,
          dataLoaded: false,
          connectionCheckingFun: null,
          connectionCheckingTimer: 10000,
          madeConnectionCalled: false,
          chatMessageInitCalled: false,
          isEditCancelOn: false,
          isShowConnectionWarning: false,
          isBlockCalled: false,
          attachments: [],
          uploadedbase64: [],
          uploadedAttachments:[],
          sheetVisible: false,
          onsendingimg: false,
          TUsers: []
        }
      },
      computed: {
        ...mapGetters([
            'AppConfig',
            'MainMenuLayout',
            'Chat',
            'resource',
            'ChannelmsgCount',
            'ChatsUser',
            'Messagenode',
            'ChatHistory',
            'getMessageEditingObj',
            'ActiveChannelId',
            'IsReconnecting',
            "MainMenuList",
        ]),
         MediaUrlCamera() {
        return this.AppConfig.Urls.ContentBaseUrl + '/.system/app_icons/outlined/35-photos-images/camera-2.svg'
      },
      MediaUrlPhotoLib() {
        return this.AppConfig.Urls.ContentBaseUrl + '/.system/app_icons/outlined/35-photos-images/picture-1.svg'
      },
        attachmentsVisible() {
          const self = this;
          return self.attachments.length > 0;
        },
        ModuleInfo() {
          return this.MainMenuList.find(
            module => module.Id === parseInt(this.SubscriptionModuleId)
          );
        },
        SubscriptionModuleId() {
          let id = this.$f7route.params.SubscriptionModuleId
          if (typeof (id) === 'undefined')
            id = ''
          return id
        },
        ChannelId() {
          let id = this.$f7route.params.ChannelId
          if (typeof (id) === 'undefined') {
            if (this.singleChannel) {
              id = this.Chat.ChatsChannels[0].id
            } else {
              id = ''
            }
          }
          this.setActiveChannelId(id)
          return id
        },
        singleChannel() {
          return (this.Chat && this.Chat.ChatsChannels && this.Chat && this.Chat.ChatsChannels.length === 1)
        },
        currentDeviceId () {
          let deviceId = Helper.getNotifyDeviceId()
          if (deviceId === null) {
            deviceId = ''
          }
          return deviceId
        },
        ChannelList () {
          let list = []
          if (this.Chat && this.Chat.ChatsChannels && this.Chat.ChatsChannels.length > 0) {
            list = this.Chat.ChatsChannels.map(x => {
              if (!Helper.IsNullOrEmpty(this.UserId)) {
                let CountMsg = this.ChannelmsgCount.find(y => y.channelId === x.id && y.subscriptionId === this.AppConfig.Subscription_Id)
                if (CountMsg ) {
                    x.unreadmsgCount = CountMsg.count
                } else {
                    x.unreadmsgCount = 0
                }
              } else {
                x.unreadmsgCount = 0
              }
              return x
            })
          }
          return list
        },
        headerElements() {
          let headerElements = ''
          if (this.Chat.Parent.HeaderElements) {
            headerElements = JSON.parse(this.Chat.Parent.HeaderElements)
          }
          return headerElements
        },
        footerElements() {
          let footerElements = ''
          if (this.Chat.Parent.FooterElements) {
            footerElements = JSON.parse(this.Chat.Parent.FooterElements);
          }
          return footerElements;
        },
        headerTitle() {
          if (this.ChannelId !== '') {
            return this.ChannelName
          } else {
            return this.Chat.Parent.PageTitle
          }
        },
        ChannelDetails () {
          let channel = {}
          if (this.ChannelId !== '') {
            if (this.Chat && this.Chat.ChatsChannels && this.Chat.ChatsChannels.length > 0) {
              channel = this.Chat.ChatsChannels.find(c => c.id === this.ChannelId)
            }
          }
          return channel
        },
        ChannelName() {
          var name = ''
          var channel = this.ChannelDetails
          if (channel) {
            name = channel.channelName
          }
          return name
        },
        UserId () {
          return this.ChatsUser.id
        },
        currentDeviceId () {
          let deviceId = Helper.getNotifyDeviceId()
          if (deviceId === null) {
            deviceId = ''
          }
          return deviceId
        }
      },
      watch : {
        UserId (val) {
          if(!Helper.IsNullOrEmpty(val)) {
            this.handleSignalRConnectivity()
            this.handleUserChecking()
          } else {
            if (!this.isBlockCalled) {
              this.manageUserExpiration(true)
            }
          }
        }
      },
      async created() {
        //console.log('chatcreated')
        await this.initChatModule(this.SubscriptionModuleId)
      },
      mounted () {
        let userregistrationpopup = document.getElementById('user-registration-popup')
        userregistrationpopup && userregistrationpopup.addEventListener("popup:close", (event, payload) => {
          //this.handleUserChecking()
        });
      },
      beforeDestroy() {
        this.handleClearInterval()
        this.setActiveChannelId('')
        this.clearTyping()
        //if (this.toastTop) this.toastTop.destroy()
      },
      methods: {
        ...mapActions([
          'resetChat',
          'resetChatHistory',
          'loadLocalChatData',
          'loadChatData',
          'getChannelList',
          'updateUserData',
          'updatChatHistory',
          'setChannelmsgCount',
          'getUserInfo',
          'setTypingUsers',
          'setResetScrollMessageFlag',
          'manageMessageEditing',
          'setActiveChannelId',
          'setResetReconnectingFlag',
          'setResetEditMessageViewPortFlag',
          'setResetMessageTypers',
          'setConnections',
          'setConnection',
          'galleysImageUpload'
        ]),
        handleActionGrid () {
          if (Helper.IsNullOrEmpty(this.UserId)) {
            this.handleSendButtonEvent(event)
            this.handleRegisterPopupOpen()
          } else {
            if (isPhoneGap()) {
              this.$refs.actionGrid.open()
            } else {
              this.$refs.fileuploader.click()
            }
          }
        },
       processTags(e){console.log('e',e)},
        deleteAttachment(image) {
          const self = this;
          self.dataURL = ""
          const index = self.attachments.indexOf(image);
          self.uploadedbase64.splice(index, 1)[0]; // eslint-disable-line
          self.attachments.splice(index, 1)[0]; // eslint-disable-line
        },
        onActionsOpened () {
          document.addEventListener("backbutton", this.onBackClick)
        },
        onActionsClosed () {
          document.removeEventListener("backbutton", this.onBackClick)
        },
        onBackClick (event) {
          this.$refs.actionGrid.close(true)
          event.preventDefault()
        },
        handleSelects(e) {
          if (typeof FileReader !== "undefined") {
            var size = document.getElementById('fileuploader').files[0].size;
            // check file size
            // if (size > 16384) {
            //   return
            // }
            if (e.target.files.length > 15) {
              this.$f7.dialog.alert(this.resource.strlimitimg ,'')
              return
            }
            let fileList = Array.prototype.slice.call(e.target.files);
            fileList.forEach(f => {
              if(!f.type.match("image.*")) {
                return;
              }
              let reader = new FileReader();
              let that = this;
              reader.onload = function (e) {
                let mediaType =  e.target.result.split(';')[0].split('/')[1]
                 if (mediaType.toLowerCase() === 'gif') {
                  that.attachments.unshift(e.target.result);
                  let imgpayload = { "ImageBase64Data": "", "Extension": "" }
                  imgpayload.Extension =  e.target.result.split(';')[0].split('/')[1]
                  imgpayload.ImageBase64Data = e.target.result.replace(/^data:image\/[a-z]+;base64,/, "")
                  that.uploadedbase64.unshift(imgpayload)
                 } else {
                    Helper.getBase64fromImageUrl(e.target.result, that)
                 }
              }
                reader.readAsDataURL(f);
              });
          }
        },
        getPicture(source) {
          if (!isPhoneGap()) {
            this.showAlert(this.resource.warning, this.resource.uploadImgWarning, false)
            return
          } else {
            if (source === 'PHOTOLIBRARY') {
              Helper.getPictureFromMedia(this)
            } else {
              Helper.getPicture(source, this)
            }
          }
        },
        async uploadImage(dataURLObj) {
         let response = ''
         let payload = {
              "Images": dataURLObj,
              "Subscription_GUID": this.$store.getters.AppConfig.Subscription_GUID,
              "IsContent":true
            }
          response = await this.galleysImageUpload(payload)
          return response
        },
        async initChatModule (SubscriptionModuleId) {
          try {
            this.dataLoaded = false
            this.madeConnectionCalled = false
            this.$showLoader()
            //console.log('SubscriptionModuleId',SubscriptionModuleId)
            await this.resetChat()
            //console.log('resetChat')
            await this.resetChatHistory()
            //console.log('resetChatHistory')
            await this.loadLocalChatData(SubscriptionModuleId)
            //console.log('loadLocalChatData')
            await this.loadChatData(SubscriptionModuleId)
            if (Helper.IsUserActionAllow()) {
              //console.log('IsUserActionAllow')
              let chatUserId = window.localStorage.getItem('chatUserId' + this.AppConfig.Subscription_Id)
              if(!Helper.IsNullOrEmpty(chatUserId)) {
                var userInfoResponse = await this.getUserInfo(chatUserId)
                if (userInfoResponse.deviceId !== this.currentDeviceId || userInfoResponse.blocked) {
                  await this.manageUserExpiration(false)
                } else {
                  await this.updateUserData(userInfoResponse)
                }
              }
            }
            let parentInfo = this.Chat ? this.Chat.Parent : null
            if (parentInfo) {
              await this.getChannelList({Id: parentInfo.Id, SubscriptionModuleId: this.SubscriptionModuleId})
              this.dataLoaded = true
              this.$hideLoader()
              this.handleSignalRConnectivity()
              this.isValidForRobotChat()
              if(!Helper.IsNullOrEmpty(this.ChannelId)) {
                this.resetChannelMessageCount()
              }
            }
          } catch (e) {
            this.$hideLoader()
            console.log('err', e)
          }
        },
        async handleSignalRConnectivity () {
          if(!Helper.IsNullOrEmpty(this.UserId) && !this.madeConnectionCalled) {
            this.madeConnectionCalled = true
            this.setActiveChannelId(this.ChannelId)
            this.assignSignalRParameters()
            await SignalRHelper.madeConnection(this.SubscriptionModuleId, this.UserId)
            this.handleClearInterval()
            this.connectionCheckingFun = setInterval(this.handleConnectionChecking, this.connectionCheckingTimer)
          }
        },
        handleConnectionChecking () {
          SignalRHelper.handleConnectionChecking()
        },
        handleClearInterval () {
          if (this.connectionCheckingFun) {
            clearInterval(this.connectionCheckingFun)
          }
        },
        isValidForRobotChat () {
          if (Helper.IsDevSim() && this.ChannelId != '') {
            this.isRobotChatOn = true
          } else {
            this.isRobotChatOn = false
          }
        },
        showChannel (value) {
          return '/chat-view/' + this.SubscriptionModuleId + '/' + value
          //this.$f7.views.main.router.navigate(`/chat-view/${this.SubscriptionModuleId}/${value}`)
        },
        getSendBtnStyle () {
          return { 'right': this.getMessageEditingObj.isEditingOn ? '47px' : '0'}
        },
        getSendSpanBtnStyle () {
          return {
            'background-image': this.getMessageEditingObj.isEditingOn ? 'url(' + editIcon + ')' :'url(' + sendIcon + ')',
            'background-position': this.getMessageEditingObj.isEditingOn ? '53% 52%' : '65% 48%',
          }
        },
        getEditCancelBtnStyle () {
          return {'right': '0',}
        },
        getEditCancelSpanBtnStyle () {
          return {
            'background-image': 'url(' + editCancelIcon + ')',
            'background-position': '52% 48%',
          }
        },
        media (value) {
          if (!Helper.IsNullOrEmpty(value)) {
            return `<div class="cover-background list-cover-image" style="background-image: url(${value})"></div>`;
          } else {
            return ""
          }
        },
        getChannelImage (value) {
          if (Helper.IsValid(value)) {
            return { 'background-image': 'url(' + this.AppConfig.Urls.ContentAssetsBaseUrl + value + ')' }
          } else {
            return {}
          }
        },
        description (value) {
          return (
            '<div class="headerOption__item"><span>' +
            value +
            '</span> </div>'
          )
        },
        badgeInfo (count) {
          return `<div class="badge" style="float:right">${count}</div>`
        },
        getUserImage(userImage) {
          if(!Helper.IsNullOrEmpty(userImage)) {
            return this.AppConfig.Urls.ContentAssetsBaseUrl+userImage
          } else {
            return imageUrl
          }
        },
        onSend (isClick, event) {
          if (isClick) {
            if (!DeviceInfo.isIOS) {
              this.sendMessage(event)
            }
          } else {
            if (DeviceInfo.isIOS) {
              this.sendMessage(event)
            }
          }
        },
        onEditCancel (isClick, event) {
          //console.log('onEditCancel', isClick, event)
          if (isClick) {
            if (!DeviceInfo.isIOS) {
              this.handleEditCancel(event)
            }
          } else {
            if (DeviceInfo.isIOS) {
              this.handleEditCancel(event)
            }
          }
        },
        onchange (event) {
          if (!Helper.IsNullOrEmpty(this.ChatsUser.id)) {
            //if (this.getMessageEditingObj.isEditingOn) {
              // this.setResetScrollMessageFlag(false)
            //}
            let typingobj = {
                'userId' : this.ChatsUser.id,
                'userName' : this.ChatsUser.userName,
                'userImage': this.ChatsUser.userImage,
                'channelId' : this.ChannelId,
                'channelName': this.channelName,
                'typing': true,
            }
            SignalRHelper.invoke(SignalRHelper.signalRClientMethods.typing, typingobj)
          }
        },
        sendMessage(event) {
          if (this.isRobotChatOn) {
            this.handleRobotChat()
          } else {
            if (Helper.IsNullOrEmpty(this.UserId)) {
              this.handleSendButtonEvent(event)
              this.handleRegisterPopupOpen()
            } else {
              if(this.$refs.messagebar) {
                // if (this.ChatsUser.banned || this.ChatsUser.blocked) {
                //   this.handleBlockedOrBannedUsers(this.ChatsUser)
                // } else {
                  this.handleUserChat(event)
                // }
              }
            }
          }
        },
        handleBlockedOrBannedUsers (obj, callFor) {
          if (obj.banned) {
            let msg = ''
            if (callFor === 'send') {
              msg = this.resource.userBannedSendMsg
            } else if (callFor === 'edit') {
              msg = this.resource.userBannedEditMsg
            } else if (callFor === 'delete') {
              msg = this.resource.userBannedDeleteMsg
            }
            this.$f7.dialog.alert(msg, '')
          } else if (obj.blocked) {
            this.handleBlockedUser()
          }
        },
        handleBlockedUser () {
          this.isBlockCalled = true
          //this.$f7.dialog.alert(this.resource.blockUserMsg, '',  this.manageUserExpiration)
          this.$f7.notification.create({
            title: this.resource.blockUserMsg,
            closeOnClick: true,
            closeTimeout: 3000,
          }).open()
          setTimeout(this.manageUserExpiration, 3000)
        },
        async handleUserChat (event) {
          this.messagebar = this.$refs.messagebar.f7Messagebar
          this.messagebar.focus()
          this.handleSendButtonEvent(event)
          const text = this.messagebar
            .getValue()
            .replace("<br>", "")
            .trim()
          this.messagebar.clear()
          if ((text.trim().length === 0 || Helper.IsNullOrEmpty(this.UserId)) && this.attachments.length === 0) {
            return
          }
          if (this.getMessageEditingObj.isEditingOn) {
            this.getMessageEditingObj.message = text
            this.handleUpdatemessage(this.getMessageEditingObj)
          } else {
            this.setResetScrollMessageFlag(true)
            if (this.uploadedbase64.length > 15) {
              this.uploadedbase64 = []
              this.attachments = []
              this.$f7.dialog.alert(this.resource.strlimitimg ,'')
              return
            } else if (this.uploadedbase64.length > 0) {
              this.onsendingimg = true
              this.attachments = []
              let that = this
              that.CloseKeyboard()
              that.$showLoader()
              let res = await that.uploadImage(this.uploadedbase64)
                // that.$showLoader()
                // let res = await that.uploadImage(this.uploadedbase64)
                if (typeof(res) !== 'undefined') {
                  that.uploadedAttachments = res
                  that.$hideLoader()
                  that.sendToSignalR(text, that.uploadedAttachments) // send text with last image bunch
                  that.onsendingimg = false
                } else {
                  that.$hideLoader()
                  that.onsendingimg = false
                  that.showAlert(that.resource.noInternetAccess, '', false)
                }
            } else {
              this.sendToSignalR(text, [])
            }
            this.uploadedAttachments =[]
            this.uploadedbase64 =[]
          }
        },
         CloseKeyboard () {
          if (isPhoneGap() && Keyboard) {
            // console.log('inside keyboard')
            Keyboard.hide()
          }
        },
        sendToSignalR (textMsg, imagedata) {
          let msgSendObject = {
            ModulesChatsChannelsId: this.ChannelId,
            ModulesChatsUsersId: this.UserId,
            MessageText: textMsg,
            MessageImage:  imagedata,
            SubscriptionModuleId: this.SubscriptionModuleId
          };
          SignalRHelper.invoke(SignalRHelper.signalRServerMethods.send, msgSendObject)
        },
        handleSendButtonEvent (event) {
          event.preventDefault()
          event.stopPropagation()
          if ((DeviceInfo.isIOS || Helper.IsNullOrEmpty(this.UserId)) && this.$refs.sendMessage) {
            this.$refs.sendMessage.blur()
          }
        },
        handleCancelBtnEvent (event) {
          event.preventDefault()
          event.stopPropagation()
          if (DeviceInfo.isIOS && this.$refs.editCancelBtn) {
            this.$refs.editCancelBtn.blur()
          }
        },
        handleRobotChat () {
          if (this.isRobotChatOn) {
              if(this.$refs.messagebar) {
              this.messagebar = this.$refs.messagebar.f7Messagebar;
              const text = this.messagebar
                .getValue()
                .replace("<br>", "")
                .trim()
              if (text.length === 0) {
                  return;
              }
              this.messagebar.clear()
              // Focus area
              this.messagebar.focus()
              this.$refs.robotChat.sendRobotMessage(text)
            }
          }
        },
        onMessageEdit (messageEditingObj) {
          this.manageMessageEditing({
              isEditingOn: messageEditingObj.isEditingOn,
              message: messageEditingObj.message,
              messageId: messageEditingObj.messageId,
              channelId: messageEditingObj.channelId,
              messageElm: messageEditingObj.messageElm
          })
          this.messagebar = this.$refs.messagebar.f7Messagebar
          this.messagebar.clear()
          this.messagebar.setValue(messageEditingObj.message)
          this.messagebar.focus()
          this.setResetEditMessageViewPortFlag(true)
        },
        handleUpdatemessage(messageEditingObj) {
          if(Helper.IsNullOrEmpty(messageEditingObj.message)) {
            this.deletemessage(messageEditingObj.message, messageEditingObj.messageId, messageEditingObj.channelId)
          } else {
            this.updatemessage(messageEditingObj.message, messageEditingObj.messageId, messageEditingObj.channelId)
          }
          this.manageMessageEditing({isEditingOn: false, message: '', messageId: '', channelId: '', messageElm: null})
        },
        deletemessage(messagetext, messageid, channelid) {
          // this.clearMessagebar()
          SignalRHelper.invoke(SignalRHelper.signalRServerMethods.delete, messageid)
        },
        updatemessage(messagetext, messageid, channelid) {
          //console.log('updatemessage')
          SignalRHelper.invoke(SignalRHelper.signalRServerMethods.update, messageid, messagetext)
        },
        clearMessagebar () {
          this.messagebar = this.$refs.messagebar.f7Messagebar
          this.messagebar.clear()
        },
        assignSignalRParameters () {
          SignalRHelper.signalRCallbacks.sendCallback = this.sendCallback
          SignalRHelper.signalRCallbacks.typingCallback = this.typingCallback
          SignalRHelper.signalRCallbacks.deleteCallback = this.deleteCallback
          SignalRHelper.signalRCallbacks.updateCallback = this.updateCallback
          SignalRHelper.signalRCallbacks.userCheckingCallback = this.userCheckingCallback
          SignalRHelper.signalRCallbacks.handleUserCheckCallback = this.handleUserChecking
          SignalRHelper.signalRCallbacks.connectionWarningCallback = this.connectionWarningCallback
          SignalRHelper.signalRCallbacks.closeWarning = this.closeConnectionWarning
          SignalRHelper.signalRCallbacks.reconnectingCallback = this.handleReconnectingCallback
          SignalRHelper.signalRCallbacks.connectionCheckingCallback = this.handleConnectionCheckingCallback
        },
        handleConnectionCheckingCallback (userInfo) {
          if(!Helper.IsNullOrEmpty(this.UserId) && userInfo && this.UserId === userInfo.id) {
            if (userInfo.blocked) {
              this.handleBlockedUser()
            }
          }
        },
        handleReconnectingCallback () {
          if (this.ChannelId !== ''&& this.UserId !== '') {
            this.setResetReconnectingFlag(true)
          }
        },
        sendCallback (msg) {
          console.log('SendToGroupCompleted')
          this.onsendingimg = false
          let chatUser = this.$store.getters.ChatsUser
          if(!Helper.IsNullOrEmpty(this.UserId) && !chatUser.blocked) {
            this.clearTyping()
            if (this.$store.getters.ActiveChannelId === msg.modulesChatsChannelsId) {
              if (msg.blocked || msg.banned) {
                if (this.UserId === msg.modulesChatsUsersId) {
                  this.handleBlockedOrBannedUsers(msg, 'send')
                }
                return
              }
              let obj = {
                ...msg,
                type : this.UserId && this.UserId === msg.modulesChatsUsersId ? 'sent' : 'received'
              }
              var chat = this.$store.getters.ChatHistory
              chat.push(obj)
              this.updatChatHistory(chat)
            } else if (!isPhoneGap()){
              if (msg.blocked || msg.banned) {
                return
              }
              var msgCountObj = this.$store.getters.ChannelmsgCount
              if(msgCountObj.length > 0 && msgCountObj.find(x => x.channelId === msg.modulesChatsChannelsId)) {
                let clonObj = msgCountObj.map(x => {
                  if (x.channelId === msg.modulesChatsChannelsId) {
                    x.count = x.count + 1
                  }
                  return x
                })
                this.setChannelmsgCount(clonObj)
              } else {
                msgCountObj.push({'count' : 1, 'channelId': msg.modulesChatsChannelsId, 'subscriptionModuleId': parseInt(this.SubscriptionModuleId), 'subscriptionId': parseInt(msg.subscriptionId)})
                this.setChannelmsgCount(msgCountObj)
              }
            }
          }
        },
        clearTyping () {
          if (this.timeouttyping) {
            clearTimeout(this.timeouttyping)
          }
          this.setResetMessageTypers({name: ''})
          this.responceInProgress = false
        },
        typingCallback (msg) {
         // this.TUsers = []
         this.clearTyping()
         var chatUser = this.$store.getters.ChatsUser
         // var TUsers = []
         if(!Helper.IsNullOrEmpty(this.UserId) && !chatUser.blocked) {
           if (this.$store.getters.ActiveChannelId === msg.channelId) {
             this.TUsers.push(msg)
             this.TUsers = uniqBy(this.TUsers, 'userId');
             var typeinguser = ''
             var strtyping = 'is typing'
             if (this.TUsers.length) {
               this.TUsers.forEach((user,index)=> {
                 if(user.typing && user.userId != chatUser.id) {
                   if (index < 2) {
                     if(user.userName) {
                       if (typeinguser.length > 0) {
                         typeinguser += ', '
                         strtyping = 'are typing'
                       }
                       typeinguser += user.userName +  ' '
                     }
                   }
                   if (index > 1) {
                     typeinguser += '... '
                   }
                 }
               })
             }
             if(typeinguser.length) {
               typeinguser +=' ' + strtyping
               this.setResetMessageTypers({name: typeinguser})
               let $this = this
               this.timeouttyping = setTimeout(function () {
                 $this.responceInProgress = false
                 $this.TUsers = []
                 typeinguser = ''
                 $this.clearTyping()
               }, 400)
             } else {
               this.responceInProgress = false
                this.TUsers = []
               this.clearTyping()
             }
           }
         }
       },
        deleteCallback (msg) {
          if (msg.banned || msg.blocked) {
            if (this.UserId === msg.userId) {
              this.handleBlockedOrBannedUsers(msg, 'delete')
            }
            return
          }
          var chatUser = this.$store.getters.ChatsUser
          if(!Helper.IsNullOrEmpty(this.UserId) && !chatUser.blocked) {

            let chats = this.$store.getters.ChatHistory
            let index = chats.indexOf(chats.find(x => x.id === msg.msgId))
            chats.splice(index, 1)
            this.updatChatHistory(chats)
          }
          this.$hideLoader()
        },
        updateCallback (msg) {
          this.clearTyping()
          if (msg.banned || msg.blocked) {
            if (this.UserId === msg.userId) {
              this.handleBlockedOrBannedUsers(msg, 'edit')
            }
            return
          }
          var chatUser = this.$store.getters.ChatsUser
          if(!Helper.IsNullOrEmpty(this.UserId) && !chatUser.blocked) {
            let chats = this.$store.getters.ChatHistory
            chats.forEach(val=> {
              if(val.id === msg.msgId) {
                val.messageText = msg.msgText
              }
            })
            this.updatChatHistory(chats)
          }
        },
        handleEditCancel (event) {
          this.handleCancelBtnEvent(event)
          this.messagebar = this.$refs.messagebar.f7Messagebar
          this.messagebar.clear()
          this.messagebar.focus()
          this.manageMessageEditing({isEditingOn: false, message: '', messageId: '', channelId: '', messageElm: null})
        },
        userCheckingCallback (userStatusInfo) {
          if (userStatusInfo) {
            var chatUser = this.$store.getters.ChatsUser
            if (userStatusInfo.userId === chatUser.id && userStatusInfo.deviceId !== chatUser.deviceId) {
              console.log('Invalid User')
              this.manageUserExpiration(true)
            }
          }
        },
        connectionWarningCallback () {
          if (!Helper.IsNullOrEmpty(this.ChannelId) && !Helper.IsNullOrEmpty(this.UserId)) {
            this.closePopups()
            this.isShowConnectionWarning = true
            if (this.$refs.connectionwarning) {
              this.$refs.connectionwarning.focus()
            }
          }
        },
        closeConnectionWarning () {
          //if (this.toastTop) this.toastTop.destroy()
          this.$f7.popover.close()
        },
        closePopups () {
          this.$f7.popover.close()
          this.$f7.dialog.close()
        },
        handleUserChecking () {
          if (this.Channel !== '' && this.UserId !== '') {
            //console.log('UserChecking')
            var chatUser = this.$store.getters.ChatsUser
            let userStatusObject = {
              UserId: chatUser.id,
              UserName: chatUser.userName,
              DeviceId: chatUser.deviceId,
              SubscriptionModuleId: chatUser.subscriptionId
            }
            SignalRHelper.invoke(SignalRHelper.signalRClientMethods.userChecking, userStatusObject)
          }
        },
        manageUserExpiration (isShowPopup) {
          Helper.removeChatUserLocalId(this.AppConfig.Subscription_Id)
          let ChatsUser = {
            id: '',
            rowDeleted: false,
            subscriptionId: 0,
            deviceId: '',
            userName: '',
            userEmail: '',
            userImage: ''
          }
          this.updateUserData(ChatsUser)
          this.resetChannelMessageCount()
          this.updatChatHistory([])
          SignalRHelper.resetConnections()
          if (DeviceInfo.isIOS) {
            window.location.href = '/'
          } else {
            this.$f7.views.main.router.navigate('/')
          }
        },
        resetChannelMessageCount () {
          var msgCountObj = this.$store.getters.ChannelmsgCount
          if(msgCountObj.length > 0 && msgCountObj.find(x => x.channelId === this.$store.getters.ActiveChannelId)) {
            let clonObj = msgCountObj.map(x => {
            if (x.channelId === this.$store.getters.ActiveChannelId) {
                x.count = 0
              }
              return x
            })
            this.setChannelmsgCount(clonObj)
          }
        },
        handleRegisterPopupOpen () {
          let popup = this.$f7.popup.get('#user-registration-popup')
            if (popup) {
            popup.open()
          }
        },
        IsValid (value) {
          return Helper.IsValid(value)
        },
      }
    }
</script>
<style scoped>
 .page-custom {
    display: flex;
    flex-direction: column;
 }
 .list .item-text {
    -webkit-box-orient: vertical;
  }
 .list-margin-topBottom-10 {
    margin: 10px 0;
  }
  .msg-write-box {
    color: rgb(0, 0, 0)!important;
  }
  .md .toolbar.messagebar {
    background-color: white;
    color: rgb(0, 0, 0);
  }
  .toolbar-chat {
    display: flex;
    order: 2;
    flex-direction: column;
    position: static;
 }
.toolbar-chat >>> textarea{
    max-height: 150px !important;
}
.warning-popup {
  background-color:rgba(0,0,0,0.7);
  font-size: 14px;
  z-index: 500;
  position: absolute;
  bottom:0px;
  text-align: center;
  padding: 12px 30px 8px;
  color: #fff;
  width: 100%;
  box-sizing: border-box;
}

.loader_wrapper {
  position: relative;
  bottom:0;
  left:0;
  height: 50px;
  width: 100%;
  z-index: 2005;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: rgba(87, 19, 36, 0.87); */
  /* background: linear-gradient(to bottom, rgba(87, 19, 36,0.5) 0%,rgba(87, 19, 36,0.15) 0%); */
}

.chatspinner {
  margin: 50px;
  height: 18px;
  width: 18px;
  animation: rotate 0.8s infinite linear;
  border: 8px solid #ffffff;
  border-right-color: transparent !important;
  border-radius: 50%;
}
@keyframes rotate {
  0%    { transform: rotate(0deg); }
  100%  { transform: rotate(360deg); }
}
.card__headerNoImage {
  padding: 0;
}

.card__headerNoImage .card__headerImageCaption {
  background-color: transparent;
}

.card__headerImage {
  min-height: 50vw;
  padding: 0px;
  background-position: 50% 50%!important;
  background-repeat: no-repeat!important;
  background-size: cover!important;
}

.card__headerNoImageCaption {
  width: 100%;
  height: 33%;
}

.card__headerImageCaption {
  width: 100%;
  height: 33%;
  background-color: rgba(28, 29, 31, 0.6);
  background: linear-gradient(180deg,transparent,rgba(0, 0, 0, 0.6) 30%, rgba(0, 0, 0, 0.8))!important;

}

.card__CaptionText {
  text-transform: uppercase;
  overflow: hidden;
  /* text-overflow: ellipsis; */
  /* white-space: nowrap; */
  padding: 10px 15px 10px;
  font-weight: bold;
  font-size: 1.0em;
  display: flex;
  justify-content: space-between;
}

.card__headerOption {
  padding: 0px 15px 10px 15px;
  overflow: hidden;
}

.card__headerOption .headerOption__description {
  float: left;
  font-size: 0.8em;
  overflow: hidden;
  display: -webkit-box;
  height:40px;
}

.sendMessageBtn {
    position: absolute;
    bottom: 0;
    width: 47px;
    height: 39px;
    background-color: transparent !important;
    cursor: default;
    z-index: 2;
}

.sendSpanBtn {
    background-size: 18px;
    border-radius: 50px;
    margin-right: 15px;
    background-repeat: no-repeat;
    min-width: 34px;
    height: 34px;
    cursor: pointer;
    border: none;
    position: relative;
    bottom: 7px;
    display: flex;
    align-self: flex-end;
}
.filedisplay {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatMain.vue